var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLixil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LIXIL_LOGO_ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 148.45",
    style: {
      enableBackground: "new 0 0 283.46 148.45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E65300;}\n\t.st1{fill:#53575A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.27,67.33c-2.05,0-3.71-1.67-3.71-3.71V11.49H0v55.6c0,10,8.1,18.1,18.1,18.1h26.69V67.33H23.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.95,67.33c-2.04,0-3.71-1.67-3.71-3.71V11.49h-19.56v55.6c0,10,8.1,18.1,18.1,18.1h26.69V67.33H261.95z "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63.92,
    y: 11.49,
    className: "st0",
    width: 19.84,
    height: 73.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.04,
    y: 11.49,
    className: "st0",
    width: 19.84,
    height: 73.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.03,45.53l24.73-34.04L162.93,0L139.9,31.7L116.87,0l-15.82,11.5l24.73,34.04 c1.12,1.54,1.12,4.07,0,5.62l-24.73,34.04l15.82,11.5l23.03-31.7l23.03,31.7l15.82-11.5l-24.73-34.04 C152.9,49.6,152.9,47.08,154.03,45.53"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,123.14c-1.78,0-3.6,0.88-5.17,2.5v-2.16h-2.91v18.35h2.91V128.3c1.21-1.26,3.25-2.6,4.92-2.6 c1.88,0,2.72,0.91,2.72,2.96v13.17h2.91v-13.24C41.78,125.18,39.76,123.14,36.4,123.14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60.22,123.49 56.68,123.49 49.69,132.25 49.69,116.52 46.78,116.52 46.78,141.83 49.69,141.83  49.69,136.32 52.74,132.83 57.41,141.83 60.82,141.83 54.76,130.34  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.28,139.62c-1.61,0-1.82-0.52-1.82-1.03v-12.54h4.14v-2.56h-4.14v-5.89h-2.91v5.89h-2.93v2.56h2.93V139 c0,2.64,1.55,3.17,4.04,3.17c1.5,0,2.51-0.15,2.96-0.28l0.15-0.04v-2.44l-0.24,0.04C80.73,139.56,80.02,139.62,79.28,139.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.59,123.14c-4.59,0-7.55,3.73-7.55,9.52c0,5.78,2.96,9.52,7.55,9.52c4.59,0,7.55-3.73,7.55-9.52 C99.14,126.88,96.18,123.14,91.59,123.14z M91.59,139.62c-2.91,0-4.65-2.6-4.65-6.96c0-4.36,1.74-6.96,4.65-6.96 c2.91,0,4.65,2.6,4.65,6.96C96.24,137.02,94.5,139.62,91.59,139.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.77,118.94c3,0,4.85,1.65,6,5.33l0.06,0.18l3.03-0.6l-0.06-0.22c-1.43-5.02-4.43-7.46-9.16-7.46 c-2.99,0-9.93,1.27-9.93,13s6.95,13,9.93,13c2.77,0,5.05-0.84,6.37-2.31v1.97h2.7v-12.39h-8.8v2.77h5.62v1.89 c0,2.56-1.51,5.3-5.75,5.3c-2.57,0-6.89-1.33-6.89-10.23C113.88,120.27,118.19,118.94,120.77,118.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.14,123.14c-4.59,0-7.55,3.73-7.55,9.52c0,5.78,2.97,9.52,7.55,9.52c4.59,0,7.56-3.73,7.56-9.52 C148.7,126.88,145.73,123.14,141.14,123.14z M141.14,139.62c-2.91,0-4.65-2.6-4.65-6.96c0-4.36,1.74-6.96,4.65-6.96 c2.91,0,4.65,2.6,4.65,6.96C145.79,137.02,144.05,139.62,141.14,139.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.97,123.14c-4.59,0-7.56,3.73-7.56,9.52c0,5.78,2.96,9.52,7.56,9.52c4.59,0,7.55-3.73,7.55-9.52 C166.52,126.88,163.56,123.14,158.97,123.14z M158.97,139.62c-2.91,0-4.65-2.6-4.65-6.96c0-4.36,1.74-6.96,4.65-6.96 c2.91,0,4.65,2.6,4.65,6.96C163.62,137.02,161.88,139.62,158.97,139.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.52,138.48l0.01-0.79v-21.17h-2.91v8.5c-1.13-0.9-2.8-1.88-4.65-1.88c-2.75,0-7.42,2-7.42,9.52 c0,7.03,4.07,9.52,7.55,9.52c1.82,0,3.57-0.71,4.6-1.83l0.29,1.49h2.7l-0.04-0.25C184.49,140.56,184.5,139.5,184.52,138.48z  M181.61,128.05v9.28c-1.75,1.71-2.85,2.29-4.3,2.29c-3.08,0-4.85-2.49-4.85-6.82c0-4.71,1.63-7.1,4.85-7.1 C178.65,125.7,180.26,126.58,181.61,128.05z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "201.85,116.52 198.67,116.52 198.67,141.83 213.26,141.83 213.26,139.07 201.85,139.07  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.82,
    y: 116.18,
    className: "st1",
    width: 2.91,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.82,
    y: 123.49,
    className: "st1",
    width: 2.91,
    height: 18.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "230.87,137.91 226.44,123.49 223.48,123.49 229.13,141.83 232.75,141.83 238.26,123.49  235.3,123.49  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.02,
    y: 116.18,
    className: "st1",
    width: 2.9,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.02,
    y: 123.49,
    className: "st1",
    width: 2.9,
    height: 18.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.28,123.14c-1.78,0-3.6,0.88-5.17,2.5v-2.16h-2.9v18.35h2.9V128.3c1.21-1.26,3.25-2.6,4.93-2.6 c1.88,0,2.72,0.91,2.72,2.96v13.17h2.91v-13.24C263.66,125.18,261.65,123.14,258.28,123.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.05,138.17c-0.79,0-1.27-0.41-1.27-1.1c0-0.71,0.4-1.19,1.2-1.43c0.9,0.26,1.69,0.47,3.17,0.47 c3.79,0,6.76-2.85,6.76-6.49c0-1.5-0.57-2.8-1.12-3.57c0.59-0.22,1.5-0.36,2.42-0.36h0.21v-2.93l-0.23,0.02 c-1.19,0.12-2.61,0.69-3.84,1.54c-1.22-0.83-2.6-1.19-4.45-1.19c-4.06,0-7,2.72-7,6.48c0,2.03,0.79,3.74,2.29,4.98 c-1.28,0.81-2.26,1.51-2.26,3.09c0,1.07,0.78,2.08,1.94,2.59c-1.77,0.97-2.73,1.89-2.73,3.62c0,3.02,2.67,4.55,7.93,4.55 c6.18,0,8.38-2.6,8.38-5.04C283.46,139.59,280.37,138.17,272.05,138.17z M274.81,125.7c2.8,0,4.34,1.44,4.34,4.06 c0,1.89-1.26,3.79-4.06,3.79c-2.59,0-4.41-1.61-4.41-3.93C270.68,127.21,272.26,125.7,274.81,125.7z M275.5,145.89 c-5.15,0-5.58-1-5.58-2.03c0-1.35,1.26-2.79,4.79-2.79c5.33,0,5.97,1.4,6,2.44C280.66,145.27,277.99,145.89,275.5,145.89z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.17,116.52 1.98,116.52 1.98,141.83 16.57,141.83 16.57,139.07 5.17,139.07  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.13,
    y: 116.18,
    className: "st1",
    width: 2.9,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.13,
    y: 123.49,
    className: "st1",
    width: 2.9,
    height: 18.35
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLixil);
export default __webpack_public_path__ + "static/media/logo-lixil.5ba39a56.svg";
export { ForwardRef as ReactComponent };